// import { AdminEarningsList } from "components/AdminEarnings";

import { AdminEarningsList } from "../../components/AdminEarningsList";
import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { FC } from "react";

export interface IAdminEarningsListPage {}

export const AdminEarningsListPage: FC<IAdminEarningsListPage> = (
  props: IAdminEarningsListPage
) => {
  return (
    <AuthenticatedLayout
      pageTitle="Payroll Earnings List"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        // { text: "Payroll Earnings", navigateTo: "/company/departments/list" },
      ]}
      mainContents={<AdminEarningsList />}
    />
  );
};
